const KATANA_TOKEN_LIST_URL = 'https://api.katana.network/v1/tokenlist'

export interface KatanaTokenListEntry {
  address: string
  name: string
  symbol: string
  decimals: number
  approved: boolean
}

interface KatanaTokenListResponse {
  tokens: {
    address: string
    name: string
    symbol: string
    decimals: number
    chainId: number
  }[]
}

let cached: KatanaTokenListEntry[] | null = null

export async function fetchKatanaTokenList(): Promise<KatanaTokenListEntry[]> {
  if (cached) return cached

  const response = await fetch(KATANA_TOKEN_LIST_URL)
  if (!response.ok) {
    throw new Error(`Failed to fetch token list: ${response.status}`)
  }

  const data: KatanaTokenListResponse = await response.json()
  cached = data.tokens
    .filter((t) => t.chainId === 747474)
    .map((t) => ({
      address: t.address,
      name: t.name,
      symbol: t.symbol,
      decimals: t.decimals,
      approved: true,
    }))

  return cached
}
